module.exports = __webpack_public_path__ + "static/bill.27c7b552.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bill.png
// module id = ./src/assets/images/bill.png
// module chunks = 35783957827783